import React from 'react';
import PropTypes from 'prop-types';

import Container from 'components/Container';
import MainPromoBlocks from 'components/promoBlocks/MainPromoBlocks';
import SizeDependedBlock from 'components/SizeDependedBlock';

import styles from './styles.module.scss';

const SectionMainPromoBlock = ({ blocks }) => (
	<div className={styles.SectionMainPromoBlock}>
		<SizeDependedBlock breakpoint="tabletMedium">
			<MainPromoBlocks blocks={blocks} />
			<Container>
				<MainPromoBlocks blocks={blocks} />
			</Container>
		</SizeDependedBlock>
	</div>
);

SectionMainPromoBlock.propTypes = {
	blocks: PropTypes.array
};

export default SectionMainPromoBlock;
